(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ctr-build-a-box-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSection(section) {
      if (!section || section.dataset.ctrBoabInit === 'true') return;
      section.dataset.ctrBoabInit = 'true';

      if (section.dataset.animate !== 'true') return;
      if (!('IntersectionObserver' in window)) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      section.classList.add('ctr-boab--will-animate');

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              section.classList.add('ctr-boab--visible');
              observer.unobserve(section);
            }
          });
        },
        { threshold: 0.15 }
      );

      observer.observe(section);
      section._ctrBoabObserver = observer;
    }

    function initAll(root) {
      (root || document)
        .querySelectorAll('.ctr-boab')
        .forEach(initSection);
    }

    initAll(document);

    document.addEventListener('shopify:section:load', function (event) {
      var target = event.target;
      if (!target) return;
      if (target.matches && target.matches('.ctr-boab')) {
        initSection(target);
      } else {
        initAll(target);
      }
    });

    document.addEventListener('shopify:section:unload', function (event) {
      var target = event.target;
      var section = target && target.matches && target.matches('.ctr-boab')
        ? target
        : target && target.querySelector && target.querySelector('.ctr-boab');
      if (section && section._ctrBoabObserver) {
        section._ctrBoabObserver.disconnect();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ctr-product-spotlight-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ctr-psh-benefits')) {
    class CtrPshBenefits extends HTMLElement {
      connectedCallback() {
        this._onChange = this._onChange.bind(this);
        this.addEventListener('change', this._onChange);
        this.sync();
      }

      disconnectedCallback() {
        this.removeEventListener('change', this._onChange);
      }

      get inputs() {
        return Array.from(this.querySelectorAll('.ctr-psh__benefit-input'));
      }

      _onChange(event) {
        const input = event.target;
        if (!input || !input.classList.contains('ctr-psh__benefit-input')) return;

        this.sync();

        const card = input.closest('.ctr-psh__benefit');
        const titleEl = card ? card.querySelector('.ctr-psh__benefit-title') : null;
        const subtextEl = card ? card.querySelector('.ctr-psh__benefit-subtext') : null;

        this.dispatchEvent(
          new CustomEvent('ctr-psh:benefit-selected', {
            bubbles: true,
            detail: {
              blockId: input.value,
              title: titleEl ? titleEl.textContent.trim() : '',
              subtext: subtextEl ? subtextEl.textContent.trim() : ''
            }
          })
        );
      }

      sync() {
        const inputs = this.inputs;
        if (!inputs.length) return;

        // Never leave the group without a selection.
        if (!inputs.some((input) => input.checked)) inputs[0].checked = true;

        inputs.forEach((input) => {
          const card = input.closest('.ctr-psh__benefit');
          if (card) card.classList.toggle('is-selected', input.checked);
        });
      }
    }

    customElements.define('ctr-psh-benefits', CtrPshBenefits);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ctr-scroll-ticker"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ctr-scroll-ticker')) {
    class CtrScrollTicker extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.ctr-ticker__track');
        if (!this.track) return;

        // Snapshot the server-rendered pair so every rebuild starts clean
        // instead of accumulating clones across resizes.
        this.baseHTML = this.track.innerHTML;

        this._onResize = this._debounce(() => this.build(), 200);
        window.addEventListener('resize', this._onResize);

        // Fonts change text width, which changes the loop distance.
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(() => this.build()).catch(() => {});
        }

        this.control = this.querySelector('.ctr-ticker__control');
        if (this.control) {
          this._onToggle = () => this.toggleAutoplay();
          this.control.addEventListener('click', this._onToggle);
        }

        this.build();
      }

      disconnectedCallback() {
        if (this._onResize) window.removeEventListener('resize', this._onResize);
        if (this._raf) cancelAnimationFrame(this._raf);
        if (this.control && this._onToggle) this.control.removeEventListener('click', this._onToggle);
      }

      toggleAutoplay() {
        this.paused = !this.paused;
      }

      get paused() {
        return this.hasAttribute('paused');
      }

      set paused(value) {
        if (value) this.setAttribute('paused', '');
        else this.removeAttribute('paused');

        if (this.control) {
          this.control.setAttribute(
            'aria-label',
            (value ? this.control.dataset.playLabel : this.control.dataset.pauseLabel) || ''
          );
        }
      }

      _debounce(fn, wait) {
        let timer;
        return () => {
          clearTimeout(timer);
          timer = setTimeout(fn, wait);
        };
      }

      build() {
        if (!this.track) return;

        this._raf = requestAnimationFrame(() => {
          this.track.innerHTML = this.baseHTML;

          const pair = Array.from(this.track.children);
          if (!pair.length) return;

          // Half the track is what one animation cycle travels. It must be at
          // least as wide as the visible area or a gap appears. Clone the whole
          // pair (never one list) so the -50% keyframe stays on a seam.
          let guard = 0;
          while (this.track.scrollWidth / 2 < this.clientWidth && guard < 6) {
            pair.forEach((list) => {
              const clone = list.cloneNode(true);
              clone.setAttribute('aria-hidden', 'true');
              this.track.appendChild(clone);
            });
            guard += 1;
          }

          // Constant px/sec regardless of how many items the client adds.
          const distance = this.track.scrollWidth / 2;
          const speed = parseFloat(this.dataset.speed) || 60;
          if (distance > 0 && speed > 0) {
            this.track.style.setProperty('--ctr-ticker-duration', distance / speed + 's');
          }
        });
      }
    }

    customElements.define('ctr-scroll-ticker', CtrScrollTicker);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
